import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import { setLoading, setSnackInfo } from '../../../redux/actions/appAction'
import { connect } from 'react-redux'
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Typography, Paper, Button, TextField } from '@material-ui/core';
import HttpService from '../../../services/httpService'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import FavoriteIcon from '@material-ui/icons/Favorite';
import '../style.css';
import backImage from '../../../assets/img/org/Pink-Blue-Texture.jpeg';
import backImage1 from '../../../assets/img/org/white-texture.webp';
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textFieldWidth: {
        width: "100%"
    },
    designui: {
        background: '#673ab7',
        marginTop: "20px",
        height: "100%"
    },
    table: {
        minWidth: 700,
    },
    pos: {
        marginBottom: 12,
    },
    container: {
        maxHeight: 550,
    },
    dateField: {
        width: '30%',
        marginTop: 20
    }
}))

const DesignStageForm = (props) => {
    const scrollRef = useRef(null);
    const getColor = (num) => {
        switch (num) {
            case 1:
                return '#e72600';
            case 2:
                return '#f96500';
            case 3:
                return '#ffe000';
            case 4:
                return '#30ad00';
            case 5:
                return '#218b00';
            default:
                return 'lightgray';
        }
    };
    const classes = useStyles();
    const history = useHistory();

    useEffect(() => {
        if (props.LEADOWNERDATA.leadId) {
            findExistingLead(props.LEADOWNERDATA.leadId)
        }
        // eslint-disable-next-line
    }, [props.LEADOWNERDATA, props.TYPEOPTION])    

    const findExistingLead = async (leadId) => {
        props.setLoading(true)
        try {
            const isExistsLead = await HttpService.findExistingCustomerSurveyLead(leadId, 'design')

            if (isExistsLead.data.length !== 0) {
                // history.push('/thank-you');
            }

        } catch (error) {
            // props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
            console.log(error)
        }
        props.setLoading(false)
    }
    const [satisfactionIndexRatioList, setSatisfactionIndexRatioList] = useState([
        { id: 1, description: 'Professionalism and attitude', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 2, description: 'Knowledge on subject matter', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 3, description: 'Understanding of requirements', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 4, description: 'Punctuality', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 5, description: 'Communication', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 6, description: 'Approachability', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 7, description: 'Design options', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 8, description: 'Designer Creativity', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 9, description: 'Promptness in response', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' }
    ]);

    const [satisfactionIndexForDesignManagerRatioList, setSatisfactionIndexForDesignManagerRatioList] = useState([
        { id: 1, description: 'Approachability', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 2, description: 'Communication', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 3, description: 'Promptness in response', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 4, description: 'Leadership', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 5, description: 'Others', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' }
    ]);

    // New state for property possession
    const [propertyPossession, setPropertyPossession] = useState('');
    const [propertyPossessionDate, setPropertyPossessionDate] = useState('');
    const [hasKeys, setHasKeys] = useState('');
    const [keysReceiptDate, setKeysReceiptDate] = useState('');

    // New state for material delivery
    const [materialDeliveryWilling, setMaterialDeliveryWilling] = useState('');
    const [materialDeliveryDate, setMaterialDeliveryDate] = useState('');

    const [designFormData, setDesignFormData] = useState({
        satisfactionIndexRatio: [],
        isDesignManagerInvolved: "",
        satisfactionIndexForDesignManager: [],
        feedback: "",
        propertyPossession: '',
        propertyPossessionDate: '',
        hasKeys: '',
        keysReceiptDate: '',
        materialDeliveryWilling: '',
        materialDeliveryDate: ''
    })
    const [disabledBtn, setDisabledBtn] = useState(true);
    const [disabledAnotherBtn, setDisabledAnotherBtn] = useState(true);
    const satisfactionIndexRadio = (event, index, data) => {
        const newSatisfactionIndexRatioList = [...satisfactionIndexRatioList];

        newSatisfactionIndexRatioList[index].actionSelected = event.target.value;
        newSatisfactionIndexRatioList[index].sortId = data.id ? data.id : data.sortId;
        newSatisfactionIndexRatioList[index].description = data.description;
        delete newSatisfactionIndexRatioList[index]['1'];
        delete newSatisfactionIndexRatioList[index]['2'];
        delete newSatisfactionIndexRatioList[index]['3'];
        delete newSatisfactionIndexRatioList[index]['4'];
        delete newSatisfactionIndexRatioList[index]['5'];
        delete newSatisfactionIndexRatioList[index]['6'];
        delete newSatisfactionIndexRatioList[index]['7'];
        delete newSatisfactionIndexRatioList[index]['8'];
        delete newSatisfactionIndexRatioList[index]['9'];
        delete newSatisfactionIndexRatioList[index]['10'];

        setDesignFormData({ ...designFormData, satisfactionIndexRatio: newSatisfactionIndexRatioList })
        let countCheck = 0;
        newSatisfactionIndexRatioList.forEach((ele, i) => {
            if (ele.hasOwnProperty('actionSelected')) {
                countCheck++
            }
        })
        if (newSatisfactionIndexRatioList.length === countCheck) {
            setDisabledBtn(false);
        } else {
            setDisabledBtn(true)
        }
    }

    const satisfactionIndexDesignManagerRadio = (event, index, data) => {
        const newSatisfactionIndexForDesginManagerRatioList = [...satisfactionIndexForDesignManagerRatioList];

        newSatisfactionIndexForDesginManagerRatioList[index].actionSelected = event.target.value;
        newSatisfactionIndexForDesginManagerRatioList[index].sortId = data.id ? data.id : data.sortId;
        newSatisfactionIndexForDesginManagerRatioList[index].description = data.description;
        delete newSatisfactionIndexForDesginManagerRatioList[index]['1'];
        delete newSatisfactionIndexForDesginManagerRatioList[index]['2'];
        delete newSatisfactionIndexForDesginManagerRatioList[index]['3'];
        delete newSatisfactionIndexForDesginManagerRatioList[index]['4'];
        delete newSatisfactionIndexForDesginManagerRatioList[index]['5'];
        delete newSatisfactionIndexForDesginManagerRatioList[index]['6'];
        delete newSatisfactionIndexForDesginManagerRatioList[index]['7'];
        delete newSatisfactionIndexForDesginManagerRatioList[index]['8'];
        delete newSatisfactionIndexForDesginManagerRatioList[index]['9'];
        delete newSatisfactionIndexForDesginManagerRatioList[index]['10'];

        setDesignFormData({ ...designFormData, satisfactionIndexForDesignManager: newSatisfactionIndexForDesginManagerRatioList })

        let countCheckOther = 0;
        newSatisfactionIndexForDesginManagerRatioList.forEach((ele, i) => {
            if (ele.hasOwnProperty('actionSelected')) {
                countCheckOther++
            }
        })
        if (newSatisfactionIndexForDesginManagerRatioList.length === countCheckOther) {
            setDisabledAnotherBtn(false);
        } else {
            setDisabledAnotherBtn(true)
        }
    }

    // Function to get today's date in YYYY-MM-DD format
    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Function to validate if date is today or in future
    const isValidFutureDate = (dateString) => {
        if (!dateString) return false;
        const selectedDate = new Date(dateString);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        selectedDate.setHours(0, 0, 0, 0);
        return selectedDate >= today;
    };

    const submitDesignForm = async () => {
        let obj = {
            ...designFormData,
            satisfactionIndexRatio: designFormData.satisfactionIndexRatio,
            satisfactionIndexForDesignManager: designFormData.satisfactionIndexForDesignManager,
            isDesignManagerInvolved: designFormData.isDesignManagerInvolved,
            feedback: designFormData.feedback,
            propertyPossession: propertyPossession,
            propertyPossessionDate: propertyPossessionDate,
            hasKeys: hasKeys,
            keysReceiptDate: keysReceiptDate,
            materialDeliveryWilling: materialDeliveryWilling,
            materialDeliveryDate: materialDeliveryDate,
            leadOwner: props.LEADOWNERDATA,
            typeOption: props.TYPEOPTION
        }
        props.setLoading(true)
        try {
            await HttpService.submitSurveyForm(obj)
            history.push('/thank-you');
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }


    useLayoutEffect(() => {
        const scrollToRight = () => {
            if (scrollRef.current) {
                const element = scrollRef.current;
                element.scrollLeft = element.scrollWidth - element.clientWidth;
            }
        };
        
        // Multiple attempts to ensure it works
        scrollToRight();
        
        const timeouts = [
            setTimeout(scrollToRight, 50),
            setTimeout(scrollToRight, 150),
            setTimeout(scrollToRight, 300)
        ];
        
        return () => {
            timeouts.forEach(clearTimeout);
        };
    }, [satisfactionIndexRatioList]);

    // Update designFormData whenever any of the new fields change
    useEffect(() => {
        setDesignFormData(prev => ({
            ...prev,
            propertyPossession,
            propertyPossessionDate,
            hasKeys,
            keysReceiptDate,
            materialDeliveryWilling,
            materialDeliveryDate
        }));
    }, [propertyPossession, propertyPossessionDate, hasKeys, keysReceiptDate, materialDeliveryWilling, materialDeliveryDate]);

    return (
        <>
            <Paper className={classes.designui}>
                <Typography variant="h6" gutterBottom style={{ marginLeft: 10, paddingTop: 20, fontSize: 27, fontWeight: 700, color: "white" }}>
                    Customer Satisfaction Survey - Design Process
                </Typography>
                <Typography variant='subtitle2' gutterBottom style={{ marginLeft: 10, fontWeight: 550, color: "white" }}>
                    CRM -{'>'} <span>Design expert</span> -{'>'} <span className="step1">Designer</span> -{'>'} Operations & Production -{'>'} Site Execution -{'>'} Beautiful home delivered.
                </Typography>
                <Typography variant='subtitle2' gutterBottom style={{ marginLeft: 10, marginTop: 15, fontWeight: 550, color: "white" }}>
                    Thank you for choosing Decorpot. It is our great pleasure to provide you the best quality of service at all stages.
                </Typography>
                <Typography variant='subtitle2' gutterBottom style={{ marginLeft: 10, marginTop: 15, fontWeight: 550, color: "white" }}>
                    Your assistance in completing this form is greatly appreciated. Your valuable feedback will help us to serve you better and enable us to work on improving our service standards.
                </Typography>
                <Typography variant='subtitle2' gutterBottom style={{ marginLeft: 10, marginTop: 15, fontWeight: 550, color: "white" }}>
                    Thank you.
                </Typography>
            </Paper>

            <Paper style={{ marginTop: "20px", borderTop: "8px solid #673ab7", borderBottom: "8px solid rgb(93, 65, 173" }}>
                <div style={{ padding: 10 }}>


                    <FormControl component="fieldset" style={{ marginBottom: 50, marginTop: 50 }}>
                        <FormLabel component="legend" style={{ color: "#000" }}>Satisfaction index -</FormLabel>
                        <FormLabel component="legend" style={{ color: "#000", marginTop: "30px" }}> <span className='satisfiedDetail'> </span> <span style={{ marginLeft: "10px", marginTop: "70px" }}>Dissatisfied </span>
                            <span className='DissatisfiedDetail'></span>
                            <span style={{ marginLeft: "10px", marginTop: "70px" }}> Satisfied</span> </FormLabel>
                    </FormControl>
                    {/* ───────────────────────  DESKTOP  ─────────────────────── */}
                    <div className="designedDesktop">
                        <Table bordered responsive className="custom-table">
                            <thead>
                                <tr>
                                    {/* description header spans same 10 cells as body */}
                                    <th colSpan={10}></th>
                                    {[1, 2, 3, 4, 5].map((num) => (
                                        <th
                                            key={num}
                                            style={{
                                                backgroundColor: getColor(num),
                                                color: '#fff',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {num}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {satisfactionIndexRatioList.sort().map((row, i) => (
                                    <tr key={i}>
                                        <td colSpan={10}>{row.description}</td>

                                        {[1, 2, 3, 4, 5].map((num) => (
                                            <td key={num} style={{ textAlign: 'center' }}>
                                                <Radio
                                                    value={String(num)}
                                                    checked={row.actionSelected === String(num)}
                                                    onChange={(e) => satisfactionIndexRadio(e, i, row)}
                                                    style={{
                                                        backgroundColor:
                                                            row.actionSelected === String(num) ? '#fde6f0' : '',
                                                    }}
                                                />
                                            </td>
                                        ))}
                                    </tr>
                                ))}

                                {/* footer icons */}
                                <tr>
                                    <td colSpan={10}></td>
                                    {[1, 2, 3, 4, 5].map((num) => (
                                        <td key={num} style={{ textAlign: 'center' }}>
                                            {num === 1 && <ThumbDownIcon style={{ color: '#e72600' }} />}
                                            {num === 5 && <ThumbUpIcon style={{ color: '#218b00' }} />}
                                        </td>
                                    ))}
                                </tr>
                            </tbody>
                        </Table>
                    </div>

                    {/* ───────────────────────  PHONE  ─────────────────────── */}
                    <div className="designedPhone" ref={scrollRef} style={{ overflowX: 'auto', width: '100%' }}>

                        <table bordered responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th colSpan={4}></th>
                                    {[1, 2, 3, 4, 5].map((num) => (
                                        <th
                                            key={num}
                                            style={{
                                                backgroundColor: getColor(num),
                                                color: '#fff',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {num}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {satisfactionIndexRatioList.sort().map((row, i) => (
                                    <tr key={i}>
                                        <td colSpan={4}>{row.description}</td>
                                        {[1, 2, 3, 4, 5].map((num) => (
                                            <td key={num} style={{ textAlign: 'center' }}>
                                                <Radio
                                                    value={String(num)}
                                                    checked={row.actionSelected === String(num)}
                                                    onChange={(e) => satisfactionIndexRadio(e, i, row)}
                                                    style={{
                                                        backgroundColor:
                                                            row.actionSelected === String(num)
                                                                ? '#fde6f0'
                                                                : '',
                                                    }}
                                                />
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                                <tr>
                                    <td colSpan={4}></td>
                                    {[1, 2, 3, 4, 5].map((num) => (
                                        <td key={num} style={{ textAlign: 'center' }}>
                                            {num === 1 && <ThumbDownIcon style={{ color: '#e72600' }} />}
                                            {num === 5 && <ThumbUpIcon style={{ color: '#218b00' }} />}
                                        </td>
                                    ))}
                                </tr>
                            </tbody>
                        </table>

                    </div>

                    <br />

                    <FormControl component="fieldset" style={{ marginBottom: 20, marginTop: 20 }}>
                        <FormLabel component="legend" style={{ color: "#000" }}>Was the Design Manager involved in your interior design journey? * </FormLabel>
                        <RadioGroup aria-label="designManagerInvolved" name="isDesignManagerInvolved"
                            onChange={(e) => setDesignFormData({ ...designFormData, [e.target.name]: e.target.value })}>
                            <FormControlLabel value="Yes" control={<Radio color="primary" />} label="Yes" />
                            <FormControlLabel value="No" control={<Radio color="primary" />} label="No" />
                            <FormControlLabel value="Not-applicable" control={<Radio color="primary" />} label="Not applicable" />
                        </RadioGroup>
                    </FormControl>
                    <br />

                    {
                        designFormData.isDesignManagerInvolved === 'Yes' && <>
                            <FormControl component="fieldset" style={{ marginBottom: 50, marginTop: 50 }}>
                                <FormLabel component="legend" style={{ color: "#000" }}>Satisfaction index -</FormLabel>
                                <FormLabel component="legend" style={{ color: "#000", marginTop: "30px" }}> <span className='satisfiedDetail'> </span> <span style={{ marginLeft: "10px", marginTop: "70px" }}>Dissatisfied </span>
                                    <span className='DissatisfiedDetail'></span>
                                    <span style={{ marginLeft: "10px", marginTop: "70px" }}> Satisfied</span> </FormLabel>
                            </FormControl>
                            <div className='designedPhone2'>
                                <table striped bordered hover style={{
                                    width: "100%",
                                    marginLeft: "0px",
                                    borderCollapse: "collapse",
                                    fontSize: "0.8rem",
                                    tableLayout: "fixed"
                                }}>
                                    <thead>
                                        <tr>
                                            <th style={{
                                                border: '1px solid lightgray',
                                                fontWeight: 500,
                                                width: "40%",
                                                minWidth: "100px",
                                                height: "auto",
                                                padding: "8px"
                                            }}></th>
                                            <th style={{
                                                backgroundColor: "#e72600",
                                                border: '1px solid lightgray',
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                width: "20%",
                                                minWidth: "40px",
                                                height: "2rem",
                                                padding: "4px"
                                            }}>
                                                <span style={{ color: "#fff", fontSize: "0.9rem" }}> 1 </span>
                                            </th>
                                            <th style={{
                                                border: '1px solid lightgray',
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                width: "20%",
                                                minWidth: "40px",
                                                height: "2rem",
                                                backgroundColor: "#f96500",
                                                padding: "4px"
                                            }}>
                                                <span style={{ color: "#fff", fontSize: "0.9rem" }}> 2 </span>
                                            </th>
                                            <th style={{
                                                border: '1px solid lightgray',
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                width: "20%",
                                                minWidth: "40px",
                                                height: "2rem",
                                                backgroundColor: "#ffe000",
                                                padding: "4px"
                                            }}>
                                                <span style={{ color: "#fff", fontSize: "0.9rem" }}> 3 </span>
                                            </th>
                                            <th style={{
                                                border: '1px solid lightgray',
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                width: "20%",
                                                minWidth: "40px",
                                                height: "2rem",
                                                backgroundColor: "#30ad00",
                                                padding: "4px"
                                            }}>
                                                <span style={{ color: "#fff", fontSize: "0.9rem" }}> 4 </span>
                                            </th>
                                            <th style={{
                                                border: '1px solid lightgray',
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                width: "20%",
                                                minWidth: "40px",
                                                height: "2rem",
                                                backgroundColor: "#218b00",
                                                padding: "4px"
                                            }}>
                                                <span style={{ color: "#fff", fontSize: "0.9rem" }}> 5 </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {satisfactionIndexForDesignManagerRatioList.sort().map((row, i) => {
                                            const labelId = `enhanced-table-checkbox-${i}`;
                                            return (
                                                <tr key={i}>
                                                    <td style={{
                                                        border: '1px solid lightgray',
                                                        fontWeight: 500,
                                                        width: "40%",
                                                        minWidth: "100px",
                                                        height: "auto",
                                                        padding: "8px",
                                                        fontSize: "0.9rem",
                                                        wordWrap: "break-word"
                                                    }}>
                                                        {row?.description}
                                                    </td>
                                                    <td style={{
                                                        border: '1px solid lightgray',
                                                        textAlign: 'center',
                                                        fontWeight: 700,
                                                        width: "12%",
                                                        minWidth: "40px",
                                                        height: "auto",
                                                        padding: "4px",

                                                    }}>
                                                        <RadioGroup
                                                            aria-label='option'
                                                            name={`customized-radios-${i}`}
                                                            value={row?.actionSelected}
                                                            onChange={(e) => satisfactionIndexDesignManagerRadio(e, i, row)}
                                                        >
                                                            <Radio
                                                                value='1'
                                                                checked={row?.actionSelected === '1'}
                                                                style={{
                                                                    backgroundColor: row?.actionSelected === '1' ? '#fde6f0' : '',
                                                                    borderRadius: row?.actionSelected === '1' ? '0px' : '',
                                                                    transform: 'scale(0.8)'
                                                                }}
                                                                name={`radio-button-demo-${i}`}
                                                                inputProps={{ 'aria-label': labelId }}
                                                            />
                                                        </RadioGroup>
                                                    </td>
                                                    <td style={{
                                                        border: '1px solid lightgray',
                                                        textAlign: 'center',
                                                        fontWeight: 700,
                                                        width: "12%",
                                                        minWidth: "40px",
                                                        height: "auto",
                                                        padding: "4px"
                                                    }}>
                                                        <RadioGroup
                                                            aria-label='option'
                                                            name={`customized-radios-${i}`}
                                                            value={row?.actionSelected}
                                                            onChange={(e) => satisfactionIndexDesignManagerRadio(e, i, row)}
                                                        >
                                                            <Radio
                                                                value='2'
                                                                checked={row?.actionSelected === '2'}
                                                                name={`radio-button-demo-${i}`}
                                                                inputProps={{ 'aria-label': labelId }}
                                                                style={{
                                                                    backgroundColor: row?.actionSelected === '2' ? '#fde6f0' : '',
                                                                    borderRadius: row?.actionSelected === '2' ? '0px' : '',
                                                                    transform: 'scale(0.8)'
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </td>
                                                    <td style={{
                                                        border: '1px solid lightgray',
                                                        textAlign: 'center',
                                                        fontWeight: 700,
                                                        width: "12%",
                                                        minWidth: "40px",
                                                        height: "auto",
                                                        padding: "4px"
                                                    }}>
                                                        <RadioGroup
                                                            aria-label='option'
                                                            name={`customized-radios-${i}`}
                                                            value={row?.actionSelected}
                                                            onChange={(e) => satisfactionIndexDesignManagerRadio(e, i, row)}
                                                        >
                                                            <Radio
                                                                value='3'
                                                                checked={row?.actionSelected === '3'}
                                                                name={`radio-button-demo-${i}`}
                                                                inputProps={{ 'aria-label': labelId }}
                                                                style={{
                                                                    backgroundColor: row?.actionSelected === '3' ? '#fde6f0' : '',
                                                                    borderRadius: row?.actionSelected === '3' ? '0px' : '',
                                                                    transform: 'scale(0.8)'
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </td>
                                                    <td style={{
                                                        border: '1px solid lightgray',
                                                        textAlign: 'center',
                                                        fontWeight: 700,
                                                        width: "12%",
                                                        minWidth: "40px",
                                                        height: "auto",
                                                        padding: "4px"
                                                    }}>
                                                        <RadioGroup
                                                            aria-label='option'
                                                            name={`customized-radios-${i}`}
                                                            value={row?.actionSelected}
                                                            onChange={(e) => satisfactionIndexDesignManagerRadio(e, i, row)}
                                                        >
                                                            <Radio
                                                                value='4'
                                                                checked={row?.actionSelected === '4'}
                                                                name={`radio-button-demo-${i}`}
                                                                inputProps={{ 'aria-label': labelId }}
                                                                style={{
                                                                    backgroundColor: row?.actionSelected === '4' ? '#fde6f0' : '',
                                                                    borderRadius: row?.actionSelected === '4' ? '0px' : '',
                                                                    transform: 'scale(0.8)'
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </td>
                                                    <td style={{
                                                        border: '1px solid lightgray',
                                                        textAlign: 'center',
                                                        fontWeight: 700,
                                                        width: "12%",
                                                        minWidth: "40px",
                                                        height: "auto",
                                                        padding: "4px"
                                                    }}>
                                                        <RadioGroup
                                                            aria-label='option'
                                                            name={`customized-radios-${i}`}
                                                            value={row?.actionSelected}
                                                            onChange={(e) => satisfactionIndexDesignManagerRadio(e, i, row)}
                                                        >
                                                            <Radio
                                                                value='5'
                                                                checked={row?.actionSelected === '5'}
                                                                name={`radio-button-demo-${i}`}
                                                                inputProps={{ 'aria-label': labelId }}
                                                                style={{
                                                                    backgroundColor: row?.actionSelected === '5' ? '#fde6f0' : '',
                                                                    borderRadius: row?.actionSelected === '5' ? '0px' : '',
                                                                    transform: 'scale(0.8)'
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                        <tr>
                                            <td style={{
                                                fontWeight: 500,
                                                width: "40%",
                                                minWidth: "100px",
                                                height: "auto",
                                                padding: "8px"
                                            }}></td>
                                            <td style={{
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                width: "12%",
                                                minWidth: "40px",
                                                height: "3rem",
                                                padding: "4px"
                                            }}>
                                                <ThumbDownIcon style={{ color: "#e72600", fontSize: "1.2rem" }} />
                                            </td>
                                            <td style={{
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                width: "12%",
                                                minWidth: "40px",
                                                height: "3rem",
                                                padding: "4px"
                                            }}></td>
                                            <td style={{
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                width: "12%",
                                                minWidth: "40px",
                                                height: "3rem",
                                                padding: "4px"
                                            }}></td>
                                            <td style={{
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                width: "12%",
                                                minWidth: "40px",
                                                height: "3rem",
                                                padding: "4px"
                                            }}></td>
                                            <td style={{
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                width: "12%",
                                                minWidth: "40px",
                                                height: "3rem",
                                                padding: "4px"
                                            }}>
                                                <ThumbUpIcon style={{ color: "#218b00", fontSize: "1.2rem" }} />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className='designedDesktop2'>
                                <Table striped bordered hover style={{
                                    width: "100%",
                                    maxWidth: "1200px",
                                    marginLeft: "20px",
                                    borderCollapse: "collapse"
                                }}>
                                    <tbody>
                                        <tr>
                                            <RadioGroup defaultValue="abc" aria-label="action" name="customized-radios" style={{ display: 'table-cell' }}>
                                                <td colSpan={10} style={{
                                                    border: '1px solid lightgray',
                                                    fontWeight: 500,
                                                    width: "50%",
                                                    minWidth: "200px",
                                                    height: "auto",
                                                    padding: "12px"
                                                }}></td>
                                                <td style={{
                                                    border: '1px solid lightgray',
                                                    textAlign: 'center',
                                                    fontWeight: 700,
                                                    width: "10%",
                                                    minWidth: "60px",
                                                    height: "auto",
                                                    backgroundColor: "#e72600",
                                                    padding: "8px"
                                                }}>
                                                    <span style={{ color: "#fff" }}> 1 </span>
                                                </td>
                                                <td style={{
                                                    border: '1px solid lightgray',
                                                    textAlign: 'center',
                                                    fontWeight: 700,
                                                    width: "10%",
                                                    minWidth: "60px",
                                                    height: "auto",
                                                    backgroundColor: "#f96500",
                                                    padding: "8px"
                                                }}>
                                                    <span style={{ color: "#fff" }}> 2 </span>
                                                </td>
                                                <td style={{
                                                    border: '1px solid lightgray',
                                                    textAlign: 'center',
                                                    fontWeight: 700,
                                                    width: "10%",
                                                    minWidth: "60px",
                                                    height: "auto",
                                                    backgroundColor: "#ffe000",
                                                    padding: "8px"
                                                }}>
                                                    <span style={{ color: "#fff" }}> 3 </span>
                                                </td>
                                                <td style={{
                                                    border: '1px solid lightgray',
                                                    textAlign: 'center',
                                                    fontWeight: 700,
                                                    width: "10%",
                                                    minWidth: "60px",
                                                    height: "auto",
                                                    backgroundColor: "#30ad00",
                                                    padding: "8px"
                                                }}>
                                                    <span style={{ color: "#fff" }}> 4 </span>
                                                </td>
                                                <td style={{
                                                    border: '1px solid lightgray',
                                                    textAlign: 'center',
                                                    fontWeight: 700,
                                                    width: "10%",
                                                    minWidth: "60px",
                                                    height: "auto",
                                                    backgroundColor: "#218b00",
                                                    padding: "8px"
                                                }}>
                                                    <span style={{ color: "#fff" }}> 5 </span>
                                                </td>
                                            </RadioGroup>
                                        </tr>
                                    </tbody>
                                    {satisfactionIndexForDesignManagerRatioList.sort().map((row, i) => {
                                        const labelId = `enhanced-table-checkbox-${i}`;
                                        return (
                                            <RadioGroup aria-label='option' name="customized-radios"
                                                value={row?.actionSelected}
                                                onChange={(e) => satisfactionIndexDesignManagerRadio(e, i, row)}
                                                style={{ display: 'block' }}>
                                                <tr>
                                                    <td colSpan={10} style={{
                                                        border: '1px solid lightgray',
                                                        fontWeight: 500,
                                                        width: "50%",
                                                        minWidth: "200px",
                                                        height: "auto",
                                                        padding: "12px",
                                                        wordWrap: "break-word"
                                                    }}>
                                                        {row?.description}
                                                    </td>
                                                    <td style={{
                                                        border: '1px solid lightgray',
                                                        textAlign: 'center',
                                                        fontWeight: 700,
                                                        width: "10%",
                                                        minWidth: "60px",
                                                        height: "auto",
                                                        padding: "8px"
                                                    }}>
                                                        <Radio
                                                            value='1'
                                                            checked={row?.actionSelected === '1'}
                                                            style={{
                                                                backgroundColor: row?.actionSelected === '1' ? '#fde6f0' : '',
                                                                borderRadius: row?.actionSelected === '1' ? '0px' : ''
                                                            }}
                                                            name="radio-button-demo"
                                                            inputProps={{ 'aria-label': labelId }}
                                                        />
                                                    </td>
                                                    <td style={{
                                                        border: '1px solid lightgray',
                                                        textAlign: 'center',
                                                        fontWeight: 700,
                                                        width: "10%",
                                                        minWidth: "60px",
                                                        height: "auto",
                                                        padding: "8px"
                                                    }}>
                                                        <Radio
                                                            value='2'
                                                            checked={row?.actionSelected === '2'}
                                                            name="radio-button-demo"
                                                            inputProps={{ 'aria-label': labelId }}
                                                            style={{
                                                                backgroundColor: row?.actionSelected === '2' ? '#fde6f0' : '',
                                                                borderRadius: row?.actionSelected === '2' ? '0px' : ''
                                                            }}
                                                        />
                                                    </td>
                                                    <td style={{
                                                        border: '1px solid lightgray',
                                                        textAlign: 'center',
                                                        fontWeight: 700,
                                                        width: "10%",
                                                        minWidth: "60px",
                                                        height: "auto",
                                                        padding: "8px"
                                                    }}>
                                                        <Radio
                                                            value='3'
                                                            checked={row?.actionSelected === '3'}
                                                            name="radio-button-demo"
                                                            inputProps={{ 'aria-label': labelId }}
                                                            style={{
                                                                backgroundColor: row?.actionSelected === '3' ? '#fde6f0' : '',
                                                                borderRadius: row?.actionSelected === '3' ? '0px' : ''
                                                            }}
                                                        />
                                                    </td>
                                                    <td style={{
                                                        border: '1px solid lightgray',
                                                        textAlign: 'center',
                                                        fontWeight: 700,
                                                        width: "10%",
                                                        minWidth: "60px",
                                                        height: "auto",
                                                        padding: "8px"
                                                    }}>
                                                        <Radio
                                                            value='4'
                                                            checked={row?.actionSelected === '4'}
                                                            name="radio-button-demo"
                                                            inputProps={{ 'aria-label': labelId }}
                                                            style={{
                                                                backgroundColor: row?.actionSelected === '4' ? '#fde6f0' : '',
                                                                borderRadius: row?.actionSelected === '4' ? '0px' : ''
                                                            }}
                                                        />
                                                    </td>
                                                    <td style={{
                                                        border: '1px solid lightgray',
                                                        textAlign: 'center',
                                                        fontWeight: 700,
                                                        width: "10%",
                                                        minWidth: "60px",
                                                        height: "auto",
                                                        padding: "8px"
                                                    }}>
                                                        <Radio
                                                            value='5'
                                                            checked={row?.actionSelected === '5'}
                                                            name="radio-button-demo"
                                                            inputProps={{ 'aria-label': labelId }}
                                                            style={{
                                                                backgroundColor: row?.actionSelected === '5' ? '#fde6f0' : '',
                                                                borderRadius: row?.actionSelected === '5' ? '0px' : ''
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            </RadioGroup>
                                        );
                                    })}
                                    <tr>
                                        <RadioGroup aria-label='option' name="customized-radios" style={{ display: 'table-cell' }}>
                                            <td colSpan={10} style={{
                                                fontWeight: 500,
                                                width: "50%",
                                                minWidth: "200px",
                                                height: "auto",
                                                padding: "12px"
                                            }}></td>
                                            <td style={{
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                width: "10%",
                                                minWidth: "60px",
                                                height: "4rem",
                                                padding: "8px"
                                            }}>
                                                <ThumbDownIcon style={{ color: "#e72600" }} />
                                            </td>
                                            <td style={{
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                width: "10%",
                                                minWidth: "60px",
                                                height: "4rem",
                                                padding: "8px"
                                            }}></td>
                                            <td style={{
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                width: "10%",
                                                minWidth: "60px",
                                                height: "4rem",
                                                padding: "8px"
                                            }}></td>
                                            <td style={{
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                width: "10%",
                                                minWidth: "60px",
                                                height: "4rem",
                                                padding: "8px"
                                            }}></td>
                                            <td style={{
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                width: "10%",
                                                minWidth: "60px",
                                                height: "4rem",
                                                padding: "8px"
                                            }}>
                                                <ThumbUpIcon style={{ color: "#218b00", marginLeft: 11 }} />
                                            </td>
                                        </RadioGroup>
                                    </tr>
                                </Table>
                            </div>


                            <br />
                        </>
                    }

                    {/* Question 1: Property Possession Status */}
                    <Paper style={{ padding: 20, marginBottom: 20, backgroundColor: '#f8f1fb' }}>
                        <FormControl component="fieldset" style={{ marginTop: 10, marginBottom: 20, width: '100%' }}>
                            <FormLabel component="legend">Have you received possession of your property? *</FormLabel>
                            <RadioGroup
                                row
                                value={propertyPossession}
                                onChange={(e) => {
                                    setPropertyPossession(e.target.value);
                                    // Reset dependent fields
                                    setPropertyPossessionDate('');
                                    setHasKeys('');
                                    setKeysReceiptDate('');
                                }}
                            >
                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                <FormControlLabel value="No" control={<Radio />} label="No" />
                            </RadioGroup>
                        </FormControl>

                        {propertyPossession === 'No' && (
                            <FormControl style={{ width: '100%', marginBottom: 20 }}>
                                <FormLabel component="legend">When do you expect to receive possession of your property? *</FormLabel>
                                <TextField
                                    type="date"
                                    value={propertyPossessionDate}
                                    onChange={(e) => {
                                        const selectedDate = e.target.value;
                                        if (isValidFutureDate(selectedDate) || selectedDate === getTodayDate()) {
                                            setPropertyPossessionDate(selectedDate);
                                        } else {
                                            props.setSnackInfo("Please select a future date", "error");
                                        }
                                    }}
                                    inputProps={{
                                        min: getTodayDate()
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    className={classes.dateField}
                                />
                            </FormControl>
                        )}

                        {propertyPossession === 'Yes' && (
                            <>
                                <FormControl component="fieldset" style={{ marginTop: 10, marginBottom: 20, width: '100%' }}>
                                    <FormLabel component="legend">Do you currently have the keys to the property? *</FormLabel>
                                    <RadioGroup
                                        row
                                        value={hasKeys}
                                        onChange={(e) => {
                                            setHasKeys(e.target.value);
                                            if (e.target.value === 'Yes') {
                                                setKeysReceiptDate('');
                                            }
                                        }}
                                    >
                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>

                                {hasKeys === 'No' && (
                                    <FormControl style={{ width: '100%', marginBottom: 20 }}>
                                        <FormLabel component="legend">When do you expect to receive the keys? *</FormLabel>
                                        <TextField
                                            type="date"
                                            value={keysReceiptDate}
                                            onChange={(e) => {
                                                const selectedDate = e.target.value;
                                                if (isValidFutureDate(selectedDate) || selectedDate === getTodayDate()) {
                                                    setKeysReceiptDate(selectedDate);
                                                } else {
                                                    props.setSnackInfo("Please select a future date", "error");
                                                }
                                            }}
                                            inputProps={{
                                                min: getTodayDate()
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                            fullWidth
                                            className={classes.dateField}
                                        />
                                    </FormControl>
                                )}
                            </>
                        )}
                    </Paper>

                    {/* Question 2: Material Delivery & Final Payment Confirmation */}
                    <Paper style={{ padding: 20, marginBottom: 20, backgroundColor: '#f8f1fb' }}>
                        <FormControl component="fieldset" style={{ marginTop: 10, marginBottom: 20, width: '100%' }}>
                            <FormLabel component="legend">
                                Are you willing to take material delivery and complete the final payment within the next 30 days? *
                            </FormLabel>
                            <RadioGroup
                                row
                                value={materialDeliveryWilling}
                                onChange={(e) => {
                                    setMaterialDeliveryWilling(e.target.value);
                                    if (e.target.value === 'Yes') {
                                        setMaterialDeliveryDate('');
                                    }
                                }}
                            >
                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                <FormControlLabel value="No" control={<Radio />} label="No" />
                            </RadioGroup>
                        </FormControl>

                        {materialDeliveryWilling === 'No' && (
                            <FormControl style={{ width: '100%', marginBottom: 20 }}>
                                <FormLabel component="legend">
                                    When would you be able to take material delivery and complete the final payment? *
                                </FormLabel>    
                                <TextField
                                    type="date"
                                    value={materialDeliveryDate}
                                    onChange={(e) => {
                                        const selectedDate = e.target.value;
                                        if (isValidFutureDate(selectedDate) || selectedDate === getTodayDate()) {
                                            setMaterialDeliveryDate(selectedDate);
                                        } else {
                                            props.setSnackInfo("Please select a future date", "error");
                                        }
                                    }}
                                    inputProps={{
                                        min: getTodayDate()
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    className={classes.dateField}
                                />
                            </FormControl>
                        )}
                    </Paper>

                    <TextField
                        label="Additional comments *"
                        size="small"
                        style={{ marginBottom: 20, textAlign: "center", marginTop: 20, width: "100%", backgroundColor: "#f8f1fb" }}
                        name="feedback"
                        multiline
                        rows={3}
                        onChange={(e) => setDesignFormData({ ...designFormData, [e.target.name]: e.target.value })}
                        variant="outlined"
                    />
                    <br />

                </div>
            </Paper>

            <Paper style={{ marginTop: 20, padding: 10 }}>
                <Button
                    onClick={() => { 
                        props.sendDataToParent({
                            ...designFormData,
                            propertyPossession,
                            propertyPossessionDate,
                            hasKeys,
                            keysReceiptDate,
                            materialDeliveryWilling,
                            materialDeliveryDate
                        })
                    }}
                    disabled={
                        designFormData.isDesignManagerInvolved === '' || 
                        designFormData.feedback === '' || 
                        disabledBtn || 
                        (designFormData.isDesignManagerInvolved === 'Yes' && disabledAnotherBtn) ||
                        // New validation for property possession
                        propertyPossession === '' ||
                        (propertyPossession === 'No' && !propertyPossessionDate) ||
                        (propertyPossession === 'Yes' && hasKeys === '') ||
                        (propertyPossession === 'Yes' && hasKeys === 'No' && !keysReceiptDate) ||
                        // New validation for material delivery
                        materialDeliveryWilling === '' ||
                        (materialDeliveryWilling === 'No' && !materialDeliveryDate)
                    }
                    variant="contained"
                    color="primary"
                    style={{ width: "20%" }}>
                    Send OTP
                </Button>
            </Paper>
        </>
    )
}

export default connect(null, { setLoading, setSnackInfo })(DesignStageForm)